module.exports = __webpack_public_path__ + "static/media/microsoft-azure.d1ad17dd.png";